import React from 'react';
import { Link } from 'react-router-dom';
import LoginHeader from '../../components/LoginHeader';

function RemindMe() {
  return (
    <div className="gray">
      <LoginHeader />

      <section className="login">
        <div className="container">
          <h2>Lembrete de senha</h2>
          <form className="grid_5" action="carteira-digital.html">
            <p>
              <input
                type="email"
                name="email"
                placeholder="Email não cadastrado ou inválido"
                className="erro"
              />
            </p>
            <p>
              <button type="submit">Enviar</button>
            </p>
            <p>
              <Link to="/">Voltar para o login</Link>
            </p>
          </form>
        </div>
      </section>
    </div>
  );
}

export default RemindMe;
